<div class="row" id="report">
    <div class="col-md-12">
        <app-header-dashboard-mrp-report>
        </app-header-dashboard-mrp-report>
    </div>
    <div class="col-md-12">
        <app-tabs-dashboard-mrp-report></app-tabs-dashboard-mrp-report>
    </div>
</div>
